/* eslint-disable no-new */
/* eslint-disable no-unused-vars */
import Vue from 'vue'
import store from '@/store'
import makeAxios from '@/dependencies/AdminAjax'
import UrlBuilder from '@/dependencies/urlBuilder'
import VueI18n from 'vue-i18n'
import VueScrollTo from 'vue-scrollto'

import BookingRequest from './components/BookingRequest.vue'
import BookingView from './components/BookingView.vue'

import BuzzFields from '@nodopiano/buzz-fields'
import '@nodopiano/buzz-fields/dist/buzz-fields.css'
import '@/assets/main.scss'

import messages from '@/translations/'

let language = document.getElementsByTagName('html')[0].getAttribute('lang') || 'en'
let locale = language.substring(0, 2)

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(VueScrollTo)

Vue.use(BuzzFields, {
  getErrors: function(resource) {
    return this.$store.getters[`${resource}/errors`]
  },
  getItems: function(resource) {
    return this.$store.getters[`${resource}/item`]
  },
  updateError: function(traverse, resource) {
    return this.$store.dispatch(`${resource}/clearError`, traverse)
  },
  updateItem: function(traverse, resource) {
    this.$store.dispatch(`${resource}/updateItem`, traverse)
  },
  restDriver: () => {},
  refreshItem: () => {},
  locale
})

Vue.prototype.$emptyObject = function(obj) {
  if (!(obj instanceof Object)) return true
  return Boolean(!Object.keys(obj).length)
}

Vue.prototype.$withoutErrors = function(resource) {
  return this.$emptyObject(
    this.$store.getters[`${resource}/errors`]
  )
}

Vue.mixin({
  beforeCreate() {
    this.$urlBuilder = new UrlBuilder()
    const options = this.$options
    if (options.ajax) this.$ajax = options.ajax
    else if (options.parent && options.parent.$ajax) { this.$ajax = options.parent.$ajax }
  }
})

const i18n = new VueI18n({ locale, messages })

function initVue(el, instance = {}) {
  if (document.querySelector(el))
    return new Vue({
      ...{
        el,
        ajax: makeAxios,
        store,
        i18n
      },
      ...instance
    })
}

window.onload = async function () {
  initVue('#booking-request', {
    render: h => h(BookingRequest),
    beforeMount: function () {
      this.$store.dispatch('setOptions', {
        privacy: this.$el.dataset.privacy,
        rules: this.$el.dataset.rules,
        canBook: !!this.$el.dataset.canbook
      })
    }
  })
  initVue('#booking-view', {
    render: h => h(BookingView),
    data: { uid: null },
    beforeMount: function () {
      this.$store.dispatch('setUid', this.$el.dataset.uid)
    }
  })
}
